import { render, staticRenderFns } from "./RecoveryForm.vue?vue&type=template&id=508078c9&scoped=true"
import script from "./RecoveryForm.vue?vue&type=script&lang=js"
export * from "./RecoveryForm.vue?vue&type=script&lang=js"
import style0 from "./RecoveryForm.vue?vue&type=style&index=0&id=508078c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508078c9",
  null
  
)

export default component.exports